/* ------------------------------------------------------------------ */
/* Constants                                                          */
/* ------------------------------------------------------------------ */
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const POLICY_REGEX = {
  length: /.{8,}/,
  upper: /[A-Z]/,
  lower: /[a-z]/,
  number: /\d/,
  special: /[^A-Za-z\d]/,
};
/** One month, in milliseconds. */
export const ONE_MONTH_MS = 30 * 24 * 60 * 60 * 1_000;

/** Admin emails that always bypass the metadata check. */
export const ERX_WHITELIST = ["lmogg@electronrx.com", "mmutic@electronrx.com"];

export const FOOTER_LINES = [
  "For Investigation Use Only",
  "Accessory to electronRx SaMD",
  "electronRx 0.2.0 2025",
];

export const LANGS = [
  { code: "en-GB", label: "English (UK)", flag: "🇬🇧" },
  // { code: "en-US", label: "English (US)", flag: "🇺🇸" },
  { code: "ja", label: "日本語", flag: "🇯🇵" },
];

// /* Registry of available questionnaires                            */
// export const QUESTIONNAIRES = [
//   // { slug: "respHealthAssessment", label: "Respiratory Health Assessment" },
//   { slug: "cat", label: "COPD Assessment Test (CAT)" },
// ];

/* Steps definition (keep here for now)                            */
export const STEPS = [
  {
    src: "/assets/instructions-1-1.png",
    alt: "Avoid wearing loose, non-fitted, plain clothing",
  },
  {
    src: "/assets/instructions-1-2.png",
    alt: "Make sure you are seated at a table",
  },
  {
    src: "/assets/instructions-1-3.png",
    alt: "Complete the recording",
  },
];
